import { CALC_MODELS } from '../../../constants';

export const getCustomCO2QuestionData = (question) => ({
  [`customCo2_${question?.outerId ?? ''}`]: {
    scopeName: `Scope ${question.data.scopeCode + 1}`,
    scopeIdx: question.data.scopeCode,
    questionName: CALC_MODELS.CUSTOM_CO2,
    questionIdx: question.outerId,
  },
});

export const addCustomCO2ToStructure = (acc, question) => {
  const { scopeCode, scopeName } = question.data ?? {};
  const finalScopeCode = `scope${scopeCode + 1}`;

  let scope = acc.find((el) => el.code === finalScopeCode);

  if (!scope) {
    scope = {
      code: finalScopeCode,
      name: scopeName,
      type: CALC_MODELS.CARBON,
      order: scopeCode,
      children: [],
    };
  }

  const newScope = {
    ...scope,
    children: [
      ...(scope.children || []).filter((el) => el.id !== question.id),
      { ...question, order: question.outerId },
    ].sort((a, b) => a.order - b.order),
  };

  return [...acc.filter((el) => el.code !== finalScopeCode), newScope].sort(
    (a, b) => a.order - b.order
  );
};

export const getCustomCO2AnswersStructure = (
  question,
  accType,
  sharedAnswersCollection,
  selectedAnswerIds
) => {
  const { scopeCode } = question?.data ?? {};
  const answer = sharedAnswersCollection[question.compositeId].find(
    (a) => a.id === selectedAnswerIds[question.compositeId]
  );
  const test = {
    ...accType,
    answers: {
      ...accType.answers,
      [question.outerId]: [...answer.data],
    },
  };
  return {
    ...accType,
    answers: {
      ...accType.answers,
      [question.outerId]: [...answer.data],
    },
  };
};
